import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import "./AboutProgram.css";

const AboutProgram: React.FC = () => {
  return (
    <div className="about-program-page">
      {/* First Section - About the Program */}
      <div className="about-section">
        <div className="about-section-container">
          <Row gutter={20} align="middle">
            <Col xs={24} lg={14}>
              <div className="about-content">
                <h1 className="about-title">About the Program</h1>
                <p className="about-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas vel aliquam tellus, ac tempor mauris. Sed at
                  tincidunt orci. Sed ac nunc ante. Praesent ut elementum justo.
                  Phasellus vitae lacus felis. Nunc tempus vitae nisl efficitur
                  viverra. Sed consectetur, orci ac condimentum aliquam, augue
                  ligula convallis felis, et pulvinar leo mauris pharetra orci.
                  Morbi aliquam, sapien a sagittis auctor, urna magna congue ex,
                  non viverra erat felis vitae ipsum.
                </p>
              </div>
            </Col>
            <Col xs={24} lg={10}>
              <div className="about-image-container">
                <img
                  src="/images/about-program-main.webp"
                  alt="E-bike program overview"
                  className="about-image"
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Second Section - Sapien A Sagittis Auctor */}
      <div className="sapien-section">
        <div className="sapien-section-container">
          <Row gutter={20} align="middle">
            <Col xs={24} lg={8} className="sapien-image-column">
              <div className="sapien-image-container">
                <img
                  src="/images/sapien-section.webp"
                  alt="E-bike transportation benefits"
                  className="sapien-image"
                />
              </div>
            </Col>
            <Col xs={24} lg={15}>
              <div className="sapien-content">
                <h2 className="sapien-title">sapien a sagittis auctor</h2>
                <p className="sapien-subtitle">
                  consectetur adipiscing elit. Maecenas vel aliquam tellus,
                </p>
                <p className="sapien-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas vel aliquam tellus, ac tempor mauris. Sed at
                  tincidunt orci. Sed ac nunc ante. Praesent ut elementum justo.
                  Phasellus vitae lacus felis. Nunc tempus vitae nisl efficitur
                  viverra.
                  <br />
                  Sed consectetur, orci ac condimentum aliquam, augue ligula
                  convallis felis, et pulvinar leo mauris pharetra orci. Morbi
                  aliquam, sapien a sagittis auctor, urna magna congue ex, non
                  viverra erat felis vitae ipsum.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Third Section - Central Title with Features */}
      <div className="features-section">
        <div className="features-header">
          <h2 className="features-main-title">sapien a sagittis auctor</h2>
          <p className="features-main-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
            vel aliquam tellus, ac tempor mauris. Sed at tincidunt orci. Sed ac.
          </p>
        </div>

        <div className="features-grid">
          <Row gutter={20}>
            <Col xs={24} lg={8}>
              <div className="feature-item">
                <img
                  src="/images/about1.png"
                  alt="Feature icon"
                  className="feature-icon"
                />
                <h3 className="feature-title">Lorem ipsum dolor</h3>
                <p className="feature-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas vel aliquam tellus, ac tempor mauris. Sed at
                  tincidunt orci. Sed ac.
                </p>
              </div>
            </Col>
            <Col xs={24} lg={8}>
              <div className="feature-item">
                <img
                  src="/images/about2.png"
                  alt="Feature icon"
                  className="feature-icon"
                />
                <h3 className="feature-title">Lorem ipsum dolor</h3>
                <p className="feature-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas vel aliquam tellus, ac tempor mauris. Sed at
                  tincidunt orci. Sed ac.
                </p>
              </div>
            </Col>
            <Col xs={24} lg={8}>
              <div className="feature-item">
                <img
                  src="/images/about3.png"
                  alt="Feature icon"
                  className="feature-icon"
                />
                <h3 className="feature-title">Lorem ipsum dolor</h3>
                <p className="feature-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas vel aliquam tellus, ac tempor mauris. Sed at
                  tincidunt orci. Sed ac.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Apply for an E-Bike Incentive Now</h2>
          <Link to="/application1">
            <button className="cta-button">Apply Now</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutProgram;
